export const products = [
	{
		id: 1,
		name: "Gamer Gear Pro Controller",
		description: "High-performance gaming controller",
		price: 59.99,
		inStock: 100,
		category: "electronics",
	},
	{
		id: 2,
		name: "Luminous VR Headset",
		description: "Immersive virtual reality experience",
		price: 199.99,
		inStock: 50,
		category: "electronics",
	},
	{
		id: 3,
		name: "TechTonic Energy Drink",
		description: "Refreshing energy boost",
		price: 2.99,
		inStock: 1000,
		category: "beverages",
	},
	{
		id: 4,
		name: "Laser Lemonade Machine",
		description: "Futuristic lemonade maker",
		price: 499.99,
		inStock: 25,
		category: "electronics",
	},
	{
		id: 5,
		name: "Hypernova Headphones",
		description: "High-fidelity audio experience",
		price: 129.99,
		inStock: 75,
		category: "electronics",
	},
	{
		id: 6,
		name: "AeroGlow Desk Lamp",
		description: "Sleek and energy-efficient lighting",
		price: 39.99,
		inStock: 200,
		category: "electronics",
	},
	{
		id: 7,
		name: "Zest Juicers",
		description: "Healthy juice extraction",
		price: 79.99,
		inStock: 100,
		category: "electronics",
	},
	{
		id: 8,
		name: "Flexi Wearables",
		description: "Comfortable and stylish fitness trackers",
		price: 49.99,
		inStock: 150,
		category: "electronics",
	},
	{
		id: 9,
		name: "Glimmer Lamps",
		description: "Ambient lighting for any space",
		price: 99.99,
		inStock: 75,
		category: "electronics",
	},
	{
		id: 10,
		name: "Aqua Filters",
		description: "Advanced water filtration system",
		price: 129.99,
		inStock: 50,
		category: "electronics",
	},
];

export const customers = [
	{
		id: 1,
		name: "John Doe",
		email: "john.doe@example.com",
		phone: "+1 (555) 123-4567",
		totalOrders: 5,
		status: "active",
	},
	{
		id: 2,
		name: "Jane Smith",
		email: "jane.smith@example.com",
		phone: "+1 (555) 987-6543",
		totalOrders: 3,
		status: "inactive",
	},
	{
		id: 3,
		name: "Bob Johnson",
		email: "bob.johnson@example.com",
		phone: "+1 (555) 246-8135",
		totalOrders: 8,
		status: "active",
	},
	{
		id: 4,
		name: "Alice Brown",
		email: "alice.brown@example.com",
		phone: "+1 (555) 369-2580",
		totalOrders: 2,
		status: "active",
	},
	{
		id: 5,
		name: "Charlie Wilson",
		email: "charlie.wilson@example.com",
		phone: "+1 (555) 147-2589",
		totalOrders: 6,
		status: "inactive",
	},
	{
		id: 6,
		name: "Eva Davis",
		email: "eva.davis@example.com",
		phone: "+1 (555) 753-9514",
		totalOrders: 4,
		status: "active",
	},
	{
		id: 7,
		name: "Frank Miller",
		email: "frank.miller@example.com",
		phone: "+1 (555) 951-7532",
		totalOrders: 1,
		status: "active",
	},
	{
		id: 8,
		name: "Grace Taylor",
		email: "grace.taylor@example.com",
		phone: "+1 (555) 357-1593",
		totalOrders: 7,
		status: "inactive",
	},
	{
		id: 9,
		name: "Henry Clark",
		email: "henry.clark@example.com",
		phone: "+1 (555) 852-9630",
		totalOrders: 3,
		status: "active",
	},
	{
		id: 10,
		name: "Ivy Anderson",
		email: "ivy.anderson@example.com",
		phone: "+1 (555) 741-8520",
		totalOrders: 5,
		status: "active",
	},
];

export const paymentMethods = [
	{ id: "credit-card", name: "Credit Card" },
	{ id: "debit-card", name: "Debit Card" },
	{ id: "cash", name: "Cash" },
];

export const CLIENT_NAME = "Centro de Distribución de Carnicos Gustavo";
export const PROJECT_CREDIT = "Desarrollo ABDev.click";
export const COUNTRY = "MX" as const;
export const DEMO_EMAIL = "test@carnicosgustavo.com";
